import { Injectable, NgZone } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { AppPartialState } from "./reducers";
import { appQuery } from "./selectors";
import * as appActions from "./actions";
import { SMBrandOwner } from "../models/SMBrandOwner";
import { SMBrand } from "../models/SMBrand";

@Injectable()
export class AppFacade {

    getSemtID$ = this.store.pipe(select(appQuery.getSemtID));
    getCredential$ = this.store.pipe(select(appQuery.getCredential));
    getUserData$ = this.store.pipe(select(appQuery.getUserData));
    getBrandData$ = this.store.pipe(select(appQuery.getBrandData));
    getNewBrandOwner$ = this.store.pipe(select(appQuery.getNewBrandOwnerData));
    getNewBrandOwnerCred$ = this.store.pipe(select(appQuery.getNewBrandOwnerCred));
    getNewBrandData$ = this.store.pipe(select(appQuery.getNewBrandData));
    getAllBrandsData$ = this.store.pipe(select(appQuery.getAllBrands));
    getTempBrandOwnerData$ = this.store.pipe(select(appQuery.getTempBrandOwnerData));

    constructor(private store: Store<AppPartialState>) { }

    resetState() {
        this.store.dispatch(appActions.resetState());
    }

    changeSemtID(newID) {
        this.store.dispatch(appActions.loadSemtIDSuccess({ semtID: newID }));
    }

    login(email: string, password: string) {
        this.store.dispatch(appActions.login({ username: email, password }));
    }

    loadCurrentUser() {
        this.store.dispatch(appActions.loadCurrentUser());
    }

    loadCurrentUserData(id: string) {
        this.store.dispatch(appActions.loadCurrentUserData({ id }));
    }

    loadCurrentBrandData(brandOwner: SMBrandOwner) {
        this.store.dispatch(appActions.loadCurrentBrandData({ id: brandOwner.brandID })); 
    }

    loadAllBrands() {
        this.store.dispatch(appActions.loadAllBrandsData());
    }

    loadTempBrandOwnerData(id : string) {
        this.store.dispatch(appActions.loadTempBrandOwnerData({ id }));
    }

    loadTempBrandData(brandOwner: SMBrandOwner) {
        this.store.dispatch(appActions.loadTempBrandData({ id: brandOwner.brandID })); 
    }

    createBrandOwnerOwnerCred(brandOwner: string, password: string) {
        this.store.dispatch(appActions.createBrandOwnerFirebaseAuth({ brandOwner, password }));
    }

    createBrandOwner(brandOwner: SMBrandOwner) {
        this.store.dispatch(appActions.createBrandOwnerData({ brandOwner }));
    }

    createBrand(brand: SMBrand) {
        this.store.dispatch(appActions.createBrandData({ brand }));
    }

    updateBrandOwner(brandOwner: SMBrandOwner) {
        this.store.dispatch(appActions.updateBrandOwnerData({brandOwner}));
    }

    updateBrand(brand:SMBrand) {
        this.store.dispatch(appActions.updateBrandData({brand}));
    }

    updateTempBrand(brand: SMBrand) {
        this.store.dispatch(appActions.updateTempBrandData({brand}));
    }

    uploadImage(file: any) {
        this.store.dispatch(appActions.uploadImage({file}));
    }
}
